import React, { useState } from "react";
import { Icon } from "@/components/Icon";
import { useAuth } from "@/context/AuthContext";
import { useMobilePrefs } from "../ui/MobilePrefs";
import { SheetBody } from "../ui/SheetHost";
import { fmtAmtNum } from "@/lib/money";

/* LaunchSheet (design 2c) — tapping a tile previews instead of jumping. Shows the
   game art + name + Original identity, a wallet selector (PCoins /
   PCash, real balances), How-to-play / Fairness links, then a thumb-reach Play.
   On Play it hands back the chosen wallet; the lobby launches (native deep-link
   or provider full-bleed host). Game-specific fairness is disclosed in game. */

export default function LaunchSheet({ close, game, onPlay }) {
  const { user, streamerMode } = useAuth();
  const { playCurrency, setPlayCurrency } = useMobilePrefs();
  const [wallet, setWallet] = useState(playCurrency);
  const mask = !!streamerMode;
  const isOriginal = !!game?.original;

  const wallets = [
    { id: "coins", name: "PCoins", bal: fmtAmtNum(user?.coins ?? 0, "coins", { mask }), icon: "pnrcoin", color: "#00D632" },
    { id: "cash", name: "PCash", bal: fmtAmtNum(user?.cash ?? 0, "cash", { mask }), icon: "pnrcash", color: "#E4E4E7" },
  ];

  const play = () => { setPlayCurrency(wallet); onPlay?.(wallet); close(); };

  return (
    <SheetBody>
      <div style={{ display: "flex", gap: 14, alignItems: "center", padding: "4px 0 16px" }}>
        <span style={{ width: 84, height: 84, flex: "none", borderRadius: 18, overflow: "hidden", background: "#141417", boxShadow: "inset 0 0 0 1px rgba(255,255,255,.08)" }}>
          {game?.img && <img src={game.img} alt={game?.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ font: "800 24px 'Manrope'", letterSpacing: "-.02em" }}>{game?.name || "Game"}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, font: "600 12px 'Outfit'", color: "#a1a1aa" }}>
            <span>{game?.providerLabel || (isOriginal ? "PRYMEBET Original" : "Provider")}</span>
          </div>
        </div>
      </div>

      <div style={{ font: "700 11px 'Outfit'", letterSpacing: ".16em", color: "#71717a", marginBottom: 10 }}>PLAY WITH</div>
      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        {wallets.map((w) => {
          const on = wallet === w.id;
          return (
            <button key={w.id} type="button" onClick={() => setWallet(w.id)} aria-pressed={on}
              style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4, padding: "12px", borderRadius: 16, textAlign: "left", border: 0, cursor: "pointer",
                background: on ? "rgba(0,214,50,.07)" : "#141417", boxShadow: on ? "inset 0 0 0 1.5px #00D632" : "inset 0 0 0 1px #26262B" }}>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <Icon name={w.icon} size={18} style={{ color: w.color }} />
                <span style={{ font: "600 11px 'Outfit'", color: "#a1a1aa" }}>{w.name}</span>
              </span>
              <span className="m-tnum" style={{ font: "800 17px 'Manrope'", color: "#fff" }}>{w.bal}</span>
            </button>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
        {["How to play", isOriginal ? "Game rules" : "Game info"].map((l) => (
          <span key={l} style={{ flex: 1, height: 42, borderRadius: 13, background: "#141417", boxShadow: "inset 0 0 0 1px #2F2F35", display: "flex", alignItems: "center", justifyContent: "center", font: "600 13px 'Outfit'", color: "#D4D4D8" }}>{l}</span>
        ))}
      </div>

      <button type="button" onClick={play}
        style={{ width: "100%", height: 56, borderRadius: 16, background: "#00D632", color: "#0A0A0A", font: "800 16px 'Manrope'", border: 0, cursor: "pointer",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,.3),0 10px 24px rgba(0,214,50,.18)", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
        Play {game?.name || ""}
      </button>
    </SheetBody>
  );
}
